import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import axios from 'axios'

import i18n from 'Pods/Shared/I18n'

import UserReview from './Components/UserReview'
import UserReviewButtons from './Components/UserReviewButtons'
import UserModelsRating from './Components/UserModelsRating'
import UserProjectsRating from './Components/UserProjectsRating'
import EmptyState from '../Components/UserEmptyState'

class UserReviews extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reviews: [{
        title: i18n.t('profilePage.modelos', { ns: 'rails', lng: props.locale }),
        type: 'model',
        reviews: [],
        total: props.userTotals.ratings.model.count,
        isVisible: true,
        page: 1,
        activeFilter: '',
        dropReviews: false,
      }, {
        title:  i18n.t('profilePage.projects', { ns: 'rails', lng: props.locale }),
        type: 'project',
        reviews: [],
        total: props.userTotals.ratings.project.count,
        isVisible: false,
        page: 1,
        activeFilter: '',
        dropReviews: false,
      }],

      isNotEmpty: this.props.userTotals.ratings.model.count > 0 || this.props.userTotals.ratings.project.count > 0,
    }

    this.swapReviews = this.swapReviews.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.onRequestSuccess = this.onRequestSuccess.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleDeleteReview = this.handleDeleteReview.bind(this)
  }

  componentDidMount() {
    if (this.state.isNotEmpty) {
      this.state.reviews.forEach((review) => {
        if (review.total > 0) {
          this.fetchData(review)
        }
      })
    }
  }

  fetchData(review) {
    axios.get(`/api/internal/profile/${this.props.userName}/reviews`, {
      params: {
        type: review.type,
        perPage: 6,
        page: review.page,
        sortBy: review.activeFilter,
      },
    }).then((response) => this.onRequestSuccess(review, response))
      .catch(this.onRequestFailure)
  }

  onRequestSuccess(review, response) {
    if (response.data.data.length) {
      const newState = this.state
      const activeReviews = newState.reviews.find((review) => review.type === response.data.meta.type)

      activeReviews.page += 1

      if (activeReviews.dropReviews) {
        activeReviews.reviews = response.data.data
        activeReviews.dropReviews = false
      } else {
        activeReviews.reviews = [...activeReviews.reviews, ...response.data.data]
      }

      this.setState({ ...newState })
    }
  }

  onRequestFailure() {
    App.events.publish('app:notification:flash:error', 'Error')
  }

  swapReviews() {
    const newState = this.state

    newState.reviews.forEach((review) => review.isVisible = !review.isVisible)

    this.setState({ ...newState })
  }

  handleDeleteReview(reviewId) {
    // eslint-disable-next-line no-alert
    if (!window.confirm('Delete this project review? This cannot be undone.')) return

    const metaToken = document.getElementsByName('csrf-token')[0]

    axios.delete(`/admin/designer_ratings/${reviewId}`, {
      headers: { 'X-CSRF-Token': metaToken?.getAttribute('content'), Accept: 'application/json' },
    }).then(() => {
      const newState = this.state
      const projectReviews = newState.reviews.find((review) => review.type === 'project')

      projectReviews.reviews = projectReviews.reviews.filter((review) => review.id !== reviewId)
      projectReviews.total -= 1

      this.setState({ ...newState })
    }).catch(this.onRequestFailure)
  }

  handleFilterChange(sort) {
    const newState = this.state
    const currentReviews = newState.reviews.find(review => review.isVisible === true)

    currentReviews.activeFilter = sort.value
    currentReviews.page = 1
    currentReviews.dropReviews = true

    this.setState({ ...newState }, this.fetchData(currentReviews))
  }

  render() {
    const { viewerIsAdmin } = this.props
    const reviews =  i18n.t('profilePage.reviews', { ns: 'rails', lng: this.props.locale })
    const reviewsGiven =  i18n.t('profilePage.reviewsGiven', { ns: 'rails', lng: this.props.locale })
    const newestFirst =  i18n.t('projects.newestFirst', { ns: 'rails', lng: this.props.locale })
    const positiveFirst =  i18n.t('profilePage.positiveFirst', { ns: 'rails', lng: this.props.locale })
    const negativeFirst =  i18n.t('profilePage.negativeFirst', { ns: 'rails', lng: this.props.locale })

    const sortOptions= [{
      label: newestFirst,
      value: '',
    }, {
      label: positiveFirst,
      value: 'positive',
    }, {
      label: negativeFirst,
      value: 'negative',
    }]

    return (
      <Fragment>
        <h2 className="heading-36">{this.props.userTotals.ratings.isBuyerReviews ? reviewsGiven : reviews}</h2>
        <div className="user-reviews__heading">
          <div className="user-reviews__heading-left">
            <UserReviewButtons reviews={this.state.reviews} onClick={this.swapReviews} />
          </div>
          <div className="user-reviews__heading-right">
            {this.state.reviews.map((review) => (
              <Fragment key={`reviews-rating-${review.type}`}>
                {!this.props.userTotals.ratings.isBuyerReviews && review.isVisible && review.type === 'model' && (
                  <UserModelsRating
                    review={review}
                    positiveRates={this.props.userTotals.ratings.model.positive}
                    negativeRates={this.props.userTotals.ratings.model.negative}
                    handleFilterChange={this.handleFilterChange}
                    locale={this.props.locale}
                  />
                )}
                {!this.props.userTotals.ratings.isBuyerReviews && review.isVisible && review.type === 'project' && (
                  <UserProjectsRating
                    review={review}
                    rating={this.props.userTotals.ratings.project.avgRating}
                    handleFilterChange={this.handleFilterChange}
                  />
                )}
              </Fragment>
            ))}
            <Select
              name="reviews-list-sort"
              value={this.state.reviews.find(review => review.isVisible === true).activeFilter}
              options={sortOptions}
              onChange={this.handleFilterChange}
              placeholder="Sort"
              className="Select-outline u-ml10"
              searchable={false}
              clearable={false}
              disabled={!this.state.isNotEmpty}
            />
          </div>
        </div>
        <div className="user-reviews__row">
          <div className="row">
            {this.state.reviews.map((review) => review.isVisible && (
            <Fragment key={`reviews-${review.type}`}>
              {review.total > 0 ? (
                review.reviews.map((review) => (
                  <div className="col-12 col-sm-6 col-lg-4 col-xl-12">
                    {review.type === 'modelRatings' ? (
                      <a href={review.attributes.productUrl} className="user-reviews__review-wrapper">
                        <UserReview key={`reviews-${review.type}-${review.id}`} {...review} locale={this.props.locale} />
                      </a>
                    ) : (
                      <UserReview
                        key={`reviews-${review.type}-${review.id}`}
                        {...review}
                        locale={this.props.locale}
                        onDelete={viewerIsAdmin ? this.handleDeleteReview : undefined}
                      />
                    )}
                  </div>
                ))
              ) : (
                review.type === 'model' ? (
                  <EmptyState text={i18n.t('profilePage.noModelsReviews', { ns: 'rails', lng: this.props.locale })} />
                ) : (
                  <EmptyState text={i18n.t('profilePage.noProjectsReviews', { ns: 'rails', lng: this.props.locale })} />
                )
              )}
              {review.reviews.length < review.total && (
              <div className="user-models__load-more-row u-text-center">
                <button
                  className="btn btn-outline-default btn-white btn-dark text-semibold"
                  onClick={() => { this.fetchData(review) }}
                >
                  {i18n.t('profilePage.loadMore', { ns: 'rails', lng: this.props.locale })}
                </button>
              </div>
              )}
            </Fragment>
            ))}
          </div>
        </div>
      </Fragment>
    )
  }
}

UserReviews.propTypes = {
  userRating: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  viewerIsAdmin: PropTypes.bool,
  userTotals: PropTypes.shape({
    ratings: PropTypes.shape({
      model: PropTypes.shape({
        negative: PropTypes.number,
        positive: PropTypes.number,
        count: PropTypes.number,
      }),
      project: PropTypes.shape({
        avgRating: PropTypes.number,
        count: PropTypes.number,
      }),
      isBuyerReviews: PropTypes.bool,
    }).isRequired,
  }).isRequired,
}

UserReviews.defaultProps = {
  viewerIsAdmin: false,
  ratings: {
    model: {
      negative: 0,
      positive: 0,
    },
    project: {
      avgRating: 0,
    },
    isBuyerReviews: false,
  },
}

export default UserReviews
